module.exports = __webpack_public_path__ + "static/media/a59.4c85d136.jpg";